import React, { useState, useEffect } from 'react';
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  TopToolbar,
  CreateButton,
  FunctionField,
  ExportButton,
  TextInput,
} from 'react-admin';
import { Card, CardContent, Box, Tabs, Tab, Typography, Alert } from '@mui/material';
import DeleteWithConfirmButton from "../../components/DeleteWithConfirmButton.tsx";
import UploadButton from '../../components/UploadButton.tsx';
import TemplateDownloadButton from '../../components/TemplateDownloadButton.tsx';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

// 在组件内添加发送邮件函数
// function handleSendEmail(supplier) {

//   const navigate = useNavigate();
//   navigate('/supplier/send-email', { state: { supplier } });
// }
const supplierFilters = [
  <TextInput sx={{
    '& .MuiInputBase-input': {
      height: 40,
      padding: '6px 12px',
      fontSize: 14,
      lineHeight: '40px',
    },
    minHeight: 36,
    marginBottom: '16px',
  }} label="Search For Name" source="name" alwaysOn resettable />,
];

const ListActions = () => {
  const navigate = useNavigate();
  return (
    <TopToolbar sx={{ position: 'relative', top: '-80px' }}>
      <TemplateDownloadButton href="/templates/supplier_template.csv" />
      <UploadButton resource="supplier" onSuccess={() => window.location.reload()} />
      <ExportButton sx={{
        textTransform: 'capitalize', '&.css-istbiy-MuiButtonBase-root-MuiButton-root': {
          marginLeft: '0 !important',
        }, top: '-5px', '& span': {
          marginRight: '2px',
        }, ml: 0,
      }} />
      <CreateButton label="New Supplier" sx={{
        top: '-5px', '& span': {
          marginRight: '2px',
        }
      }} />
    </TopToolbar>
  );
};

const ActionButtons = ({ record }: { record?: any }) => {
  const navigate = useNavigate();
  if (!record) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', width: '100%' }}>
      <EditButton record={record} sx={{
        textTransform: 'capitalize', '& span': {
          marginRight: '2px',
        }
      }} />
      <DeleteWithConfirmButton record={record} resource="supplier" />
    </div>
  );
};

const SupplierList = (props) => {
  const navigate = useNavigate();
  const handleSendEmail = (supplier) => {
    navigate('/supplier/send-email', { state: { supplier } });
  };
  const [tab, setTab] = useState(0);
  const [expiringSuppliers, setExpiringSuppliers] = useState<any[]>([]);
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5180/api';
  const [expandedSupplierId, setExpandedSupplierId] = useState<string | null>(null);

  useEffect(() => {
    // 请求后端接口，获取最近一月将要过期的供应商
    fetch(`${API_URL}/supplier/expiring`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      }
    })
      .then(res => res.json())
      .then(data => {
        setExpiringSuppliers(data ?? []);
      });
  }, [API_URL]);

  return (
    <Card sx={{ margin: 1 }}>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 0 }}>
        <Tab label="Supplier List" />
        <Tab label="Expiring Reminder" />
      </Tabs>
      <CardContent>
        {tab === 0 && (
          <List
            empty={false}
            filters={supplierFilters}
            {...props}
            actions={<ListActions />}
          >
            <Box sx={{
              maxWidth: 'calc(100vw - 290px)',
              overflowX: 'auto',
            }}>
              <Box>
                <Datagrid rowClick={false} sx={{
                  '& .RaDatagrid-headerCell': { textAlign: 'center' },
                  '& .RaDatagrid-rowCell': { textAlign: 'center' },
                }}>
                  {/* <TextField source="id" label="Supplier id" /> */}
                  <TextField source="name" label="Name" />

                  <TextField source="address" label="Address" />
                  <FunctionField label="Actions" render={record => <ActionButtons record={record} />} />
                </Datagrid>
              </Box>
            </Box>
          </List>
        )}
        {tab === 1 && (
          <Box>
            <Typography variant="h6" gutterBottom>Suppliers Expiring Within One Month</Typography>
            {expiringSuppliers.length === 0 ? (
              <Alert severity="info">No supplier certificates will expire within one month.</Alert>
            ) : (
              <>
                <Alert severity="warning" sx={{ mb: 2 }}>
                  The following suppliers' certificates will expire within one month. Please handle promptly!
                </Alert>
                <Box sx={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'center', borderBottom: '1px solid #eee' }}>Name</th>
                        <th style={{ textAlign: 'center', borderBottom: '1px solid #eee' }}>Address</th>
                        <th style={{ textAlign: 'center', borderBottom: '1px solid #eee' }}>Email Status</th>
                        <th style={{ textAlign: 'center', borderBottom: '1px solid #eee' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {expiringSuppliers.map(supplier => (
                        <React.Fragment key={supplier.id}>
                          <tr
                            style={{ cursor: 'pointer', background: expandedSupplierId === supplier.id ? '#f5faff' : undefined }}
                            onClick={() => setExpandedSupplierId(expandedSupplierId === supplier.id ? null : supplier.id)}
                          >
                            <td style={{ textAlign: 'center', padding: 8 }}>{supplier.name}</td>
                            <td style={{ textAlign: 'center', padding: 8 }}>{supplier.address}</td>
                            <td style={{ textAlign: 'center', padding: 8 }}>{supplier.emailStatus}</td>
                            <td style={{ textAlign: 'center', padding: 8 }}>
                              <button
                                style={{
                                  padding: '4px 12px',
                                  background: supplier.emailStatus === "Sent" ? '#ccc' : '#1976d2',
                                  color: supplier.emailStatus === "Sent" ? '#888' : '#fff',
                                  border: 'none',
                                  borderRadius: 4,
                                  cursor: supplier.emailStatus === "Sent" ? 'not-allowed' : 'pointer',
                                  height: 32,
                                  fontWeight: 'bold',
                                }}
                                disabled={supplier.emailStatus === "Sent"}
                                onClick={e => {
                                  e.stopPropagation();
                                  handleSendEmail(supplier);
                                }}
                              >
                                Send Email
                              </button>
                            </td>
                          </tr>
                          {expandedSupplierId === supplier.id && (
                            <tr>
                              <td colSpan={4} style={{ background: '#f9f9f9', padding: 0 }}>
                                <Box sx={{ p: 2 }}>
                                  {supplier.factories?.length > 0 ? (
                                    supplier.factories.map((factory, fIdx) => (
                                      <Box key={fIdx} sx={{ mb: 2 }}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
                                          FactoryName：{factory.name}（{factory.address}）
                                        </Typography>
                                        {factory.certificates?.length > 0 ? (
                                          <table style={{ width: '100%', marginTop: 8, marginBottom: 8, borderCollapse: 'collapse' }}>
                                            <thead>
                                              <tr>
                                                <th style={{ textAlign: 'left', borderBottom: '1px solid #eee' }}>Certificate Name</th>
                                                <th style={{ textAlign: 'left', borderBottom: '1px solid #eee' }}>Issue Date</th>
                                                <th style={{ textAlign: 'left', borderBottom: '1px solid #eee' }}>Expiry Date</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {factory.certificates.map((cert, cIdx) => (
                                                <tr key={cIdx}>
                                                  <td style={{ textAlign: 'left', paddingTop: 8 }}>{cert.name}</td>
                                                  <td style={{ textAlign: 'left', paddingTop: 8 }}>{cert.issueDate}</td>
                                                  <td style={{ textAlign: 'left', paddingTop: 8 }}>{cert.expiryDate}</td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        ) : (
                                          <Typography variant="body2" color="text.secondary" sx={{ ml: 2 }}>No certificates.</Typography>
                                        )}
                                      </Box>
                                    ))
                                  ) : (
                                    <Typography variant="body2" color="text.secondary" sx={{ ml: 2 }}>No factories.</Typography>
                                  )}
                                </Box>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </Box>
              </>
            )}
          </Box>
        )}

      </CardContent>
    </Card>
  );
};

export default SupplierList;